import moment from 'moment'
import arcService from '@/services/arc-api-dynamic.service'

export default {
    authorizations: (state) => {
        return state.authorizations.map(authorization => {
            return {
                id: authorization.authorizationCode,
                beneficiary: authorization.beneficiaryId,
                status: arcService.getStatus(authorization),
                statusSlug: authorization.status,
                amount: authorization.amount,
                currency: authorization.currency,
                amountAuthorized: authorization.currency ? 
                    authorization.currency.concat(' ', authorization.amount.toLocaleString()) : '',
                productStatus: authorization.productStatus,
                iconConfiguration: arcService.getIcon(authorization.productStatus),
                statusConfiguration: arcService.getColor(authorization),
                type: arcService.getType(authorization.coverageType),
                coverageType: authorization.coverageType,
                date: moment(authorization.createdAt).format('DD/MM/YYYY HH:mm'),
                reimbursementId: authorization.reimbursementId,
                authorizationId: authorization.id
            }
        })
    },
    page: (state) => state.page,
    authorizationLoading: (state) => state.authorizationLoading,
    authorizationCommentLoading: (state) => state.authorizationCommentLoading,
    authorizationPage: (state) => {
        const { page } = state;
        return { ...page, number: page.number + 1 }
    },
    authorizationForms: (state) => state.authorizationForms,
    authorizationFormsAndSteps: (state) => state.authorizationFormsAndSteps,
    currentForm: (state) => state.currentForm,
    currentStep: (state) => state.currentStep,
    formSteps: (state) => {
        if (state.currentForm) {
            return state.authorizationFormsAndSteps[state.currentForm].length
        }        
        return 2
    },
    getError: (state) => state.error,
    files: (state) => state.files,
    inputs: (state) => state.inputs,
    stepError: (state) => state.stepError,
    sponsorSlug: (state) => state.sponsorSlug,
    generalBalance: (state) => state.beneficiary.generalBalance,
    reimbursementStatus: (state) => state.reimbursementStatus,
    claimType: (state) => state.claimType,
    coverageBalanceDetail: (state) => state.beneficiary.coverageCostSharings,
    listAuthorization: (state) => state.listAuthorization,
    authorization: (state) => {
        const filesAndInputs = {};
        if (Object.keys(state.authorization).length === 0) {
            return {}
        } else {
            filesAndInputs['files'] = state.authorization.isReimbursement ? state.authorization.reimbursementFiles : state.authorization.authorizationFiles;
            filesAndInputs['inputs'] = state.authorization.isReimbursement ? state.authorization.reimbursementInputs : state.authorization.authorizationInputs;
        }

        return {
            ...state.authorization,
            ...filesAndInputs,
            statusLabel: arcService.getStatus(state.authorization),
            iconConfiguration: arcService.getIcon(state.authorization.productStatus),
            statusConfiguration: arcService.getColor(state.authorization),
            type: state.authorization.coverageType && arcService.getType(state.authorization.coverageType) || '',
        }
    },
    beneficiaryCountryCode: (state) => state.beneficiary.nationalityCountryCode,
    isReimbursement: (state) => state.isReimbursement,
    authorizationCreated: (state) => state.authorizationCreated
}